export default {
	rights: {
		title: '权限管理',
		operatorManage: '操作员管理',
		roleManage: '角色管理',
		groupLabel: '群组',
		roleLabel: '角色',
		statusLabel: '状态',
		nameLabel: '名称',
		usernameLabel: '登录名',
		phoneLabel: '手机号',
		emailLabel: '邮箱',
		createNewOperator: '新增操作员',
		search: '查询',
		clear: '重置',
		lastLoginTime: '最后登录时间',
		operator: '操作员',
		action: '操作',
		detail: '详情',
		notAssigned: '未分配',
		seeAll: '全部',
		collapse: '收起',
		all: '全部',
		statusTrue: '启用',
		statusFalse: '禁用',
		phoneEmail: '手机号 & 邮箱',
		roleName: '角色名',
		createNewRole: '新增新角色',
		roleDesc: '角色描述',
		updateTime: '更新时间',
		delete: '删除',
		tips: '您确定要禁用此操作员吗？ 该操作员将无法登录后台？',
		tips1: '您确定要启用此操作员吗？',
		displayOp: '禁用操作员',
		enabledOp: '启用操作员',
		enabled: '启用',
		sure: '禁用',
		cancel: '取消',
		tips2: '删除角色',
		tips3: '您确定要删除此角色吗？',
		tips4: '该角色还有操作员使用，确认删除该角色',
		tipTitle: '提示'
	},
	detail: {
		operatorDetail: '操作员详情',
		resetPassword: '重置密码',
		editOperator: '编辑操作员',
		delOperator: '删除操作员',
		delOperatorTip: '此操作将删除该操作员, 是否继续?',
		operatorName: '操作员名称',
		affiliatedGroup: '群组',
		roleInfo: '角色信息',
		create: '创建时间',
		roleDetail: '角色详情',
		roleManage: '角色管理',
		rolePermission: '角色权限',
		operatorInfo: '操作员信息',
		edit: '编辑'
	},
	edit: {
		editOperator: '编辑操作员',
		createOperator: '新增操作员',
		basicInfo: '基本信息',
		tips: '操作员只能看到他们分配的群组的数据',
		allgroups: '全部群组',
		tips2: '此选项包括您将来要创建的群组。',
		groupNotAssigned: '未分配群组',
		groupAssigned: '已分配群组',
		roleInfo: '角色信息',
		tips3: '分配角色后，操作员将获得该角色的权限。',
		save: '保存',
		cancel: '取消',
		create: '创建',
		tips4: '新增操作员后，名称将无法修改',
		password: '密码',
		repeatPassword: '重复密码',
		errorPwd: '密码必须为英文开头 包含数字、大小写字母任意两种 6-20字符',
		errorName: '请输入名字',
		errorUsername: '请输入登录名',
		errorPhone: '请输入手机号',
		errorPhoneRNM: '请输入正确的手机号',
		errorEmail: '请输入邮箱',
		errorEmailFm: '请输入正确的邮箱格式',
		errorPassword: '请输入密码',
		errorRepeatPassword: '确认密码',
		errorRoleName: '请输入角色名称',
		errorRoleDesc: '请输入角色描述',
		difPassword: '密码不匹配。',
		saveSuccess: '保存成功',
		addSuccess: '新增成功',
		delSuccess: '删除成功',
		editRole: '编辑角色',
		createRole: '创建新角色',
		tip5: '权限设置精确到按钮级别。 如果未选中按钮许可，则操作员无法单击按钮进行操作。 添加权限后，操作员将具有页面和按钮显示以及操作权限。',
		resetPwd: '重置密码',
		newPwd: '新密码',
		confirmPwd: '确认密码',
		reset: '重置',
		checkAll: '全选',
		roles: '分配角色',
		repeatName: '操作员名称重复',
		repeatLogin: '登录名重复',
		repeatPhone: '手机号重复',
		repeatEmail: '邮箱重复',
		editSuccess: '修改成功'

	}
}
